module.exports = __webpack_public_path__ + "static/img/douyin.539a492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douyin.png
// module id = v5a8
// module chunks = 68